import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

import { Price } from './price.types';
import { TranslocoModule } from '@jsverse/transloco';
import { yesCurrencyPipe } from '../../pipes/yes-currency.pipe';

@Component({
  selector: 'app-price',
  imports: [TranslocoModule, yesCurrencyPipe],
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceComponent {
  @Input({ required: true })
  priceValue!: Price;

  @Input()
  @HostBinding('class')
  size: 'sm' | 'md' | 'lg' = 'md';

  @Input({ transform: booleanAttribute })
  @HostBinding('class.yes-price-cart-style')
  isCart = false;
}
